<div @statisticsState
  class="statistics-audits-container">
  
  <pm-audit-trail-audits [data]="data"></pm-audit-trail-audits>

</div>
